
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(5(099|154|190)|(154|251|787)5)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
